import styled from "@emotion/styled/macro";
import { colors } from "../../../../../common/styles/theme.styles";

export const TagsDropdownContainer = styled.div`
    width: 280px;
    max-height: 380px;
    background: #fff;
    border: 1px solid ${colors.gray3};
    border-radius: 12px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const TagsDropdownHeader = styled.div`
    padding-top: 16px;
    font-family: Circular;
    font-size: 12px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.gray2};
    flex-shrink: 0;
`;

export const TagsDropdownBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 8px 8px;
    overflow-y: auto;
`;

export const TagOption = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    height: 36px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${colors.lightGray2};
    }

    &:active {
        background: ${colors.lightGray2};
    }
`;

export const TagCheckbox = styled.div`
    position: relative;
    width: 18px;
    height: 18px;

    input {
        opacity: 0;
        position: absolute;
        cursor: pointer;
        width: 100%;
        height: 100%;
        margin: 0;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        width: 18px;
        height: 18px;
        background-color: #fff;
        border: 1.125px solid ${colors.gray3};
        border-radius: 5.4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);

        svg {
            opacity: 0;
            transition: opacity 0.2s ease;
        }
    }

    input:checked ~ .checkmark {
        background-color: ${colors.darkGray1};
        border-color: ${colors.darkGray1};

        svg {
            opacity: 1;
        }
    }

    &:hover .checkmark {
        border-color: ${colors.darkGray1};
    }
`;

export const TagIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.5px;
    position: relative;
    overflow: hidden;

    svg {
        position: relative;
        z-index: 1;
    }
`;

export const TagLabel = styled.div`
    font-family: Circular;
    font-size: 14px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.darkGray1};
    flex: 1;
`; 